<template lang="">
    <div class="flex flex-col">
        

        <div class="mb-3 pb-3 border border-l-0 border-r-0 border-t-0 border-b-1 border-[#D0D5DD]">
                                 <div class="flex justify-between items-center py-2">
                                    <h2 class="text-lg font-bold text-[#101828]">Upcoming Workshops </h2>
                                    <a href="/employer/workshops" class="border border-[#D0D5DD] rounded-full p-1 w-[32px] h-[32px] flex items-center justify-center text-[#101828] hover:bg-[#0A0446] hover:text-white"><i class="ti ti-chevron-right"></i></a>
                                 </div>

                                 <div class="flex items-center gap-3 mb-3">
    <img src="../../../../assets/images/ig-thumb.png" class="w-[64px] h-[64px] rounded-[8px]">
    <div class="flex flex-col">
        <router-link :to="'/employee/workshop/' + upcomingWorkshop.id">
            <h3 class="text-base font-semibold text-[#101828]">{{ upcomingWorkshop.title }}</h3>
        </router-link>
        <p class="text-xs font-normal text-[#667085] line-clamp-1">
            {{ upcomingWorkshop.description.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 100) }}
        </p>
    </div>
</div>

                                
                              </div>



    </div>
</template>
<script>
export default {
  name: "upcomingWorkshopsList",
  props: {
    upcomingWorkshopsList: {},
    upcomingfilePath: String,
  },
  methods: {
    registerForWorkshop(id) {
      this.$emit("registerForWorkshop", id); // Emitting an event to call parent function
    },
  },
};
</script>
<style lang=""></style>



// WEBPACK FOOTER //
// src/components/employee/dashboard/sidebar/UpcomingWorkshops.vue